<template>
  <section class="main-testimonials">
    <div class="main-testimonials" itemscope itemtype="http://schema.org/Organization">
      <div class="main-testimonials-title">{{ getLocalization("feedback about us") }}</div>
      <div class="main-testimonials-slider">
      <div v-for="(review, index) in reviews" :key="index" itemscope itemtype="http://schema.org/Review">
        <div itemprop="reviewRating" itemscope itemtype="http://schema.org/Rating">
          <meta itemprop="ratingValue" :content="review['rating']"/>
          <meta itemprop="bestRating" content="5"/>
          <meta itemprop="worstRating" content="1"/>
        </div>
        <div itemprop="itemReviewed" itemscope itemtype="http://schema.org/Organization">
          <meta itemprop="name" content="smsbower"/>
        </div>
        <div itemprop="author" itemscope itemtype="http://schema.org/Person">
          <meta itemprop="name" :content="review['user']['login']" />
        </div>
        <div class="testimonials-card" :class="getColorClass(index)">
          <div class="testimonials-card-title">{{ review['user']['login'] }}</div>
          <div class="testimonials-card-rating">
            <img v-for="i in Number(review['rating'])" src="img/svg/testimonials/star.svg" :alt="i"/>
            <meta itemprop="ratingValue" :content="review['rating']"/>
          </div>
          <div class="testimonials-card-text" itemprop="reviewBody">
            {{ review['content'] }}
          </div>
        </div>
      </div>
    </div>
      <div class="main-testimonials-btn">
        <button v-if="isUserAuthorized" class="button orange" data-bs-toggle="modal" data-bs-target="#reviewModal" type="button">
          <img src="img/svg/testimonials/pen.svg" alt="">
          {{getLocalization('Leave your review')}}
        </button>
        <button v-else class="button orange" type="button" data-bs-toggle="modal" data-bs-target="#testimonialsModal">
          <img src="/img/svg/common/client-profile-white.svg" alt="">
          {{ getLocalization("You must be logged in to leave a review") }}
        </button>
      </div>
    </div>
    <div class="modal fade custom-modal" id="reviewModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content modal-wrapper">
          <div class="modal-title">{{getLocalization('Leave your review')}}</div>
          <div class="testimonials-modal-form">
            <div class="--full">
              <div class="input-label">{{getLocalization('Your Name')}}</div>
              <textarea
                  v-model="reviewText"
                  type="text"
                  class="input textarea"
                  placeholder="Текст вашего отзыва"
              ></textarea>
            </div>

            <div>
              <div class="input-label">{{getLocalization('Your rate')}}</div>
              <div class="rating-items">
                <div
                    v-for="(item) in 5"
                    :class="{'--selected': Boolean(item <= rating)}"
                    @click="changeRating(item)"
                ></div>
              </div>
            </div>

            <div>
              <button
                  class="button orange --action-button"
                  :disabled="Boolean(!isAcceptPrivacy || !isAcceptOffer)"
                  type="button"
                  data-bs-dismiss="modal"
                  @click="sendReview"
              >
                <img src="/img/svg/common/message.svg"/>
                {{ getLocalization('Leave your feedback') }}
              </button>
              <div class="--action-checkbox">
                <label>
                  <input v-model="isAcceptPrivacy" type="checkbox" class="checkbox"/>
                  <div>
                    {{getLocalization('I agree')}} <a href="#">{{getLocalization('with the privacy policy and use of the requested data')}}</a>
                  </div>
                </label>
                <label>
                  <input v-model="isAcceptOffer" type="checkbox" class="checkbox"/>
                  <div>
                    {{getLocalization('I agree')}} <a href="#">{{getLocalization('with public offer')}}</a>
                  </div>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade custom-modal-notification" id="reviewModalSuccess" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content custom-modal-notification">
          <img src="/img/png/notification/create-review.png" class="custom-modal-notification__image"/>
          <div class="custom-modal-notification__message">{{getLocalization('Your feedback has been successfully added')}}!</div>
          <div class="custom-modal-notification__button">
            <button
                class="button orange"
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#reviewModalSuccess"
            >
              {{getLocalization('Okay')}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import BaseAdminMixin from "../../../admin/components/mixins/BaseAdminMixin";
import Modal from '../../../components/table/modal.vue';

export default {
  name: "reviews",
  mixins: [
    BaseAdminMixin
  ],
  components: {
    Modal
  },
  props: [
    'user',
    'loginRoute'
  ],
  mounted() {
    if (this.user) {
      this.isUserAuthorized = true;
    }
    this.getReviews();
  },
  data: function () {
    return {
      reviews: [],
      isUserAuthorized: false,
      rating: 0,
      reviewText: '',
      isAcceptPrivacy: true,
      isAcceptOffer: true,
    }
  },
  methods: {
    async getReviews() {
      this.reviews = await this.sendRequest('/reviews/webReviews', 'get');
    },
    async sendReview() {
      await this.doWithStopRequest(async () => {
        let response = await this.sendRequest(
            '/cabinet/reviews/add',
            'post',
            {
              userId: this.user.id,
              rating: this.rating,
              content: this.reviewText
            }
        );

        if (response.status === 'ok') {
          let myModal = new bootstrap.Modal(document.querySelector('#reviewModalSuccess'));
          myModal.show();
        }
      }, 'Review sending')
    },
    getColorClass(index) {
      const colors = ['light-green', 'blue', 'dark-green', 'green', 'purple'];
      const colorIndex = index % colors.length;
      return colors[colorIndex];
    },
    changeRating(val) {
      this.rating = val;
    }
  },
}
</script>

